import React from "react";
import { PieChart, Pie, Legend } from "recharts";

// const data = [
//   { name: "Leads that need action", value: 30, fill: "#6842D9", textC: "#fff" },
//   { name: "Appointments booked", value: 30, fill: "#E5DAFB", textC: "#000" },
//   { name: "Leads converted", value: 40, fill: "#F4F0FD", textC: "#000" },
// ];
const renderColorfulLegendText = (value, entry) => {
  return (
    <span style={{ color: "#596579", fontWeight: 500, padding: "5px" }}>
      {value}
    </span>
  );
};
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  payload,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
  const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
  return (
    <text
      x={x}
      y={y}
      fill={payload.textC}
      textAnchor="middle"
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const renderCustomizedLabel1 =({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,  percent,

  value,
  index, payload
}) => {
  console.log("handling label?");
  const RADIAN = Math.PI / 180;
  // eslint-disable-next-line
  const radius = 25 + innerRadius + (outerRadius - innerRadius);
  // eslint-disable-next-line
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  // eslint-disable-next-line
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
    x={x}
    y={y}
    fill={payload.textC}
    textAnchor="middle"
    dominantBaseline="central"
  >
    {`${(percent * 100).toFixed(0)}%`}
  </text>
  );
}
const Example = (props) => {
  const { list } = props;
  console.log(list);
  
  const data = [
    {
      name: "Leads that need action",
      value: list?.leads_need_action_count,
      fill: "#6842D9",
      textC: "#000",
    },
    {
      name: "Appointments booked",
      value: list?.total_booking_appointment,
      fill: "#E5DAFB",
      textC: "#000",
    },
    {
      name: "Leads converted",
      value: list?.leads_converted_count,
      fill: "#F4F0FD",
      textC: "#000",
    },
  ];
  return (
    <>
    <div>
      <span className="dashboard-heading mb-4">Lead Management</span>
    </div>
    <PieChart width={700} height={220}>
      <text x={250} y={153} textAnchor="top" dominantBaseline="top">
        Total Leads
      </text>
      <text
        x={250}
        y={183}
        fontSize={32}
        fontWeight={700}
        textAnchor="top"
        dominantBaseline="top"
      >
        {list?.total_leads}
      </text>
      <Legend
        iconType="square"
        layout="vertical"
        verticalAlign="top"
        iconSize={15}
        formatter={renderColorfulLegendText}
      />
      <Pie
        data={data}
        cx={90}
        cy={30}
        innerRadius={30}
        outerRadius={80}
        fill="#8884d8"
        paddingAngle={0}
        dataKey="value"
        label={renderCustomizedLabel}
      >
        {/* {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))} */}
        {/* <Label
          value={`Total Leads`}
          position="centerBottom"
          fontSize={12}
          fill="#000"
        />
        <Label style={{marginTop:'10px'}} value={`${totalCount}`} position="centerTop" fill="#000" /> */}
      </Pie>
    </PieChart>
    </>
  );
};
export default Example;
